module.exports = __webpack_public_path__ + "img/NAA-logo-horizontal.3ef74205.svg";